import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlayerAuctionService } from '../../player-auction.service';
import { ContractAccount } from '../../player-auction.type';
import { LoginInfo } from '../../../login-info/login-info.type';
import { EmailLoginField } from '../../../shared/components/email-login-field/email-login-field';

export interface AccountFormDialogData {
  account?: ContractAccount;
}

@Component({
  selector: 'app-account-form-dialog',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    EmailLoginField,
  ],
  templateUrl: './account-form-dialog.html',
  styleUrl: './account-form-dialog.scss',
})
export class AccountFormDialog implements OnInit {
  isEdit: boolean;
  name: string = '';
  loginInfoEmailControl = new FormControl<string>('', { nonNullable: true });
  selectedLoginInfo: LoginInfo | null = null;
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<AccountFormDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AccountFormDialogData,
    private service: PlayerAuctionService,
    private snackBar: MatSnackBar,
  ) {
    this.isEdit = !!data?.account;
  }

  ngOnInit(): void {
    if (this.data?.account) {
      this.name = this.data.account.name;
      this.loginInfoEmailControl.setValue(this.data.account.login_info_email);
    }
  }

  onLoginInfoChange(loginInfo: LoginInfo | null): void {
    this.selectedLoginInfo = loginInfo;
  }

  onSubmit(): void {
    if (!this.selectedLoginInfo) {
      this.snackBar.open('Select a valid login info account', 'Close', { duration: 4000 });
      return;
    }
    this.loading = true;

    if (this.isEdit) {
      this.service.updateContractAccount(this.data.account!.id, {
        name: this.name,
        login_info_id: this.selectedLoginInfo.id,
      }).subscribe({
        next: () => {
          this.snackBar.open('Account updated', 'Close', { duration: 4000 });
          this.dialogRef.close(true);
        },
        error: (err: { error?: { error?: string } }) => {
          this.snackBar.open(err.error?.error || 'Error updating account', 'Close', { duration: 5000 });
          this.loading = false;
        },
      });
    } else {
      this.service.createContractAccount({ login_info_id: this.selectedLoginInfo.id, name: this.name }).subscribe({
        next: () => {
          this.snackBar.open('Account created', 'Close', { duration: 4000 });
          this.dialogRef.close(true);
        },
        error: (err: { error?: { error?: string } }) => {
          this.snackBar.open(err.error?.error || 'Error creating account', 'Close', { duration: 5000 });
          this.loading = false;
        },
      });
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
